import { buildUrl } from './utils';

const state = {
  users: {
    signin: '/users/signin',
    signup: '/users/signup',
    root: '/users/',
    me: '/users/me'
  }
};
const actions = {
  signin({ state }, { email, password }) {
    const url = buildUrl(state.users.signin);
    return this._vm.$http
      .post(url, {
        email,
        password
      })
      .then(({ data }) => Promise.resolve(data));
  },
  signup({ state }, { email, password, matchPassword, name }) {
    const url = buildUrl(state.users.signup);
    return this._vm.$http
      .post(url, {
        email,
        password,
        matchPassword,
        name
      })
      .then(({ data }) => Promise.resolve(data));
  },
  updateUserPicture({ rootState: { token } }, formData) {
    const url = buildUrl('users');
    return this._vm.$http.put(url, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  getUsers({ state, rootState: { token } }) {
    const url = buildUrl('users');
    return this._vm.$http
      .get(url, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      .then(({ data }) => Promise.resolve(data));
  },
  createUser({ rootState: { token } }, body) {
    const url = buildUrl('users');

    return this._vm.$http.post(url, body, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  updateUser({ rootState: { token } }, { _id, body }) {
    const url = buildUrl([
      {
        users: _id
      }
    ]);
    return this._vm.$http.put(url, body, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  deleteUser({ rootState: { token } }, _id) {
    const url = buildUrl([
      {
        users: _id
      }
    ]);

    return this._vm.$http.delete(url, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  // User Manager
  getCurrentUserData({ state, rootState: { token } }) {
    const url = buildUrl(state.users.me);
    return this._vm.$http
      .get(url, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      .then(({ data }) => Promise.resolve(data));
  },
  updateCurrentUser({ rootState: { token } }, { name, email, password, matchPassword, _id }) {
    const url = buildUrl([
      {
        users: _id
      }
    ]);

    return this._vm.$http.put(
      url,
      {
        name,
        email,
        password,
        matchPassword
      },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
  },
  get({ rootState: { token } }, { basic, withoutMe } = {}) {
    const params = {};
    if (basic) {
      params.basic = true;
    }
    if (withoutMe) {
      params.withoutMe = true;
    }
    const url = buildUrl(state.users.root);
    return this._vm.$http
      .get(url, {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params
      })
      .then(({ data }) => Promise.resolve(data));
  }
};
export default {
  namespaced: true,
  state,
  actions
};
